import React from 'react';

function HowItWorks() {
  document.title = `How It Works | Quizza`;
  return (
    <div style={{paddingTop : '50px'}}>
      <h3> coming soon...</h3>
    </div>
  );
}

export default HowItWorks;
